export enum DeficiencyTypes {
  UTAlarm = 'UTAlarm',
  Redlining = 'Redlining',
  Emergency = 'Emergency',
  High = 'High',
  Standard = 'Standard',
  Routine = 'Routine',
  Observation = 'Observation',
}
